import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const Header = ({ session, onLogout }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
    { to: "/placements", label: "Placements" },
  ];

  const handleLogout = () => {
    onLogout();
    navigate("/");
    setMenuOpen(false);
  };

  const roleDashboard = {
    Admin: "/admin",
    Trainer: "/trainer",
    Trainee: "/trainee",
  };

  return (
    <header className={`site-header ${menuOpen ? "menu-open" : ""}`}>
      <div className="header-inner">
        <div className="brand">
          <img src="/magicbus_logo.jpeg" alt="Magic Bus" className="brand-logo" />
          <div className="brand-text">
            <Link to="/">Magic Bus TMS</Link>
            <span>Transforming Education &amp; Livelihood</span>
          </div>
        </div>
        <button
          className="menu-toggle"
          onClick={() => setMenuOpen((value) => !value)}
          aria-label="Toggle navigation"
        >
          <span />
          <span />
          <span />
        </button>
        <nav className="main-nav">
          {navLinks.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </NavLink>
          ))}
          {!session && (
            <NavLink to="/login" onClick={() => setMenuOpen(false)}>
              Login
            </NavLink>
          )}
        </nav>
        <div className="header-actions">
          {session ? (
            <>
              <button className="ghost" onClick={handleLogout}>
                Logout
              </button>
              <button
                className="primary"
                onClick={() => {
                  navigate(roleDashboard[session.role]);
                  setMenuOpen(false);
                }}
              >
                Dashboard
              </button>
            </>
          ) : (
            <>
              <NavLink className="ghost" to="/login" onClick={() => setMenuOpen(false)}>
                Login
              </NavLink>
              <NavLink className="primary" to="/register" onClick={() => setMenuOpen(false)}>
                Get Started
              </NavLink>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
